function findTheFontSize(docDefinition) {
  if (docDefinition) {
    for (let i = 0; i < docDefinition.content.length; i++) {
      const text = docDefinition.content[i] && docDefinition.content[i].text;
      if (text) {
        if (text.length === 8) {
          docDefinition.content[i].fontSize = 125;
          docDefinition.content[i].margin = [0, 20, 0, 20];
        } else if (text.length === 9) {
          docDefinition.content[i].fontSize = 110;
          docDefinition.content[i].margin = [0, 23, 0, 23];
        } else if (text.length === 10) {
          docDefinition.content[i].fontSize = 95;
          docDefinition.content[i].margin = [0, 27, 0, 27];
        } else if (text.length === 11) {
          docDefinition.content[i].fontSize = 85;
          docDefinition.content[i].margin = [0, 35, 0, 35];
        } else if (text.length === 12) {
          docDefinition.content[i].fontSize = 75;
          docDefinition.content[i].margin = [0, 35, 0, 35];
        } else if (text.length > 13) {
          docDefinition.content[i].fontSize = 55;
          docDefinition.content[i].margin = [0, 35, 0, 35];
        }
      }
    }
  }
}


export const generateManyPagesForContent = ({packages_data = []}) => {
  const docDefinition = {
    pageSize: 'A5',
    pageOrientation: 'landscape',
    pageMargins: [2, -20, 2, 5],
    content: [],
    defaultStyle: {},
    styles: {
      header: {
        fontSize: 140,
        alignment: 'center',
        lineHeight: 0.8
      },
      subheader: {
        fontSize: 25,
        alignment: 'center'
      },
      subsubheader: {
        fontSize: 25,
        alignment: 'left'
      }
    }
  };

  for (let i = 0; i < packages_data.length; i++) {
    const {package_nr, barcode_img, sizes, quality, attributes, amount, generalInformation, children, serial_nr} = packages_data[i];
    docDefinition.content.push(
      {
        text: package_nr ? package_nr.toUpperCase() : '-',
        alignment: 'center',
        lineHeight: 0.8,
        fontSize: 140,
        pageBreak: i !== 0 ? 'before' : null,
        margin: 5
      },
      {image: barcode_img, width: 585, height: 97, margin: 5},
      {
        columns: [
          {
            width: '100%',
            margin: [13, 3, 0, 0],
            table: {
              widths: ['62%', '36%'],
              body: [
                [{
                  text: sizes, border: [true, true, false, false], fontSize: 51,
                  alignment: 'left', bold: true
                }, {text: quality, style: 'subheader', fontSize: 51}],
                [{text: attributes, border: [true, false, false, false], fontSize: 35}, {
                  text: amount,
                  style: 'subheader',
                  fontSize: 35
                }],
                [{
                  text: generalInformation,
                  border: [true, false, false, true],
                  fontSize: 25
                }, {text: serial_nr, style: 'subheader'}]
              ]
            }
          }
        ]
      }
    );
    if (children && children.length > 0) {
      const table = {
        pageBreak: 'before',
        margin: [5, 15, 5, 5],
        table: {
          widths: [570],
          body: [
            [{
              text: package_nr,
              style: 'subheader',
              margin: [5, 15, 5, 15],
              border: [false, false, false, false]
            }]
          ]
        }
      };
      for (let j = 0; j < children.length; j++) {
        table.table.body.push([{
          text: children[j],
          style: 'subsubheader',
          border: [true, true, true, true]
        }]);
      }
      docDefinition.content.push(table);
    }
  }
  findTheFontSize(docDefinition);
  return docDefinition;
}



// WEBPACK FOOTER //
// ./src/helpers/createPdfLabel.js